import React from 'react';

/**
 * Non-interactive icon which is not highlighted on hover. Should be used in pair with @InteractiveIcon
 * @return {JSX.Element}
 * @constructor
 */
export default function NonInteractiveIcon(props: React.PropsWithChildren<any>) {
  return (
    <span className="rounded-sm w-6 text-center inline-block mr-0.5">
      {props.children}
    </span>
  );
}
